<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101326"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      custom-class="dialogStyle"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_Code')">
            <el-input v-model="editDialog.form.code" no="code" />
          </el-form-item>
          <el-form-item required :label="$t('CargoMsg.Cargo_Name')">
            <el-input v-model="editDialog.form.name" no="name" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getListFunc, saveTransportTypeFunc, deleteTransportTypeFunc } from '@/api/basicData/transportType'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'TransportType',
  components: {},
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'name',
          width: 200
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          code: '',
          name: ''
        }
      },
      platformDialog: {
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const loading = getLoading()
      getListFunc(this.filter).then(res => {
        if (this.gridApi) {
          this.gridApi.setRowData(res.data.list)
        } else {
          this.rowData = res.data.list
        }
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          code: '',
          name: ''
        }
        this.editDialog.title = this.$t('common.btn.new') + this.$t('CargoMsg.Cargo_SourceOfClient')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_Modify') + this.$t('CargoMsg.Cargo_SourceOfClient')
      }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      if (!form.name) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NameCanTBeEmpty'))
        return
      }
      saveTransportTypeFunc(form).then(res => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.toQuery()
        this.editDialog.visible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
      }).catch(() => {
        this.editDialog.visible = false
      })
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        deleteTransportTypeFunc(rows[0].uuid).then(res => {
          this.filter.pageNum = 1
          this.toQuery()
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    }
  }
}
</script>

<style>
</style>
